import React, { Fragment, useMemo, useState, useEffect } from "react";

import classes from './SideNav.module.css'
import SideNavItem from "../sideNavItem/sidNavItemV2/SideNavV2-Item";

import SeachIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Navigation Icons/__Search.svg'
import ActivityIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activity.png'
import AllSites from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png'
import Users from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import Groups from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/groups.png'
import CCTV from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png'
import Locks from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/locks.png'
import Keybox from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/keybox.png'
import Sensor from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sensor.png'
import Logout from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Navigation Icons/__Logout.svg'
import PortalActivity from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/group.png'
import Offline from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/offline.png'
import Controller from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/controller.png'
import GatewayIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortalG.png'
import Dashboard from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dashboard.png'
import Schedule from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/schedule.png'
import emptySitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/empty.png'
import inactiveSitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/inactiveSidebar.png'
import activeSitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeSidebar.png'
import holidayIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hmIcon.png'
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from "../../../../store/ui-slice";
import { useNavigate } from "react-router-dom";

import EyeSpyFXLogo from '../../../../assets/eyespyfx-logo.png';
import ParfasLogo from "../../../../assets/parfas-logo.png"
import ResureLogo from "../../../../assets/resure-logo.png"
import KnowioLogo from "../../../../assets/knowio-logo.png"
import PortalLogo from "../../../../assets/portal-logo.png"
import TowerLogo from '../../../../assets/tower-logo.png'
import ctsgLogo from '../../../../assets/solar-logo.png'
import { getBranding } from "../../../../Api Methods/Api";

const SideNav = ({ cssClass }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const ApiData = {
        token,
        client
    }
    const dispatch = useDispatch();

    const companyName = useSelector(state => state.auth.companyName);
    const [brandingName, setBrandingName] = useState("")

    const [loadedLogo, setLoadedLogo] = useState(false)

    useEffect(() =>{
        //Fetch brand on mount
        const GetBrandingName = async () => {
            let body = {
                groupName: companyName
            }

            const response = await getBranding(ApiData, body, dispatch)
            if (response.success){
                setBrandingName(response.data["emailBranding"])
            }
        }

        GetBrandingName();
    }, [])

    const DefaultNavItems = [
        {
            name: 'Dashboard',
            imgSrc: Dashboard,
            route: '/Dashboard',
            end: true
        },
        {
            name: 'All sites',
            route: 'AllSites',
            imgSrc: AllSites,
            
        },
        
        {
            name: 'Active sites',
            route: 'ActiveSites',
            imgSrc: activeSitesIcon,
        },
        {
            name: 'Inactive sites',
            route: 'InactiveSites',
            imgSrc: inactiveSitesIcon,
        },
        {
            name: 'Controllers',
            route: 'Controllers',
            imgSrc: Controller,
        },
        {
            name: 'Offline controllers',
            route: 'Offline',
            imgSrc: Offline,
        },
        {
            name: 'Holiday mode',
            route: 'SitesOnSchedule',
            imgSrc: holidayIcon,
        },
        {
            name: 'Scheduled sites',
            route: 'ScheduledActions',
            imgSrc: Schedule,
        },
        {
            name: 'Users',
            route: 'Users',
            imgSrc: Users,
        },
    ];

  
        DefaultNavItems.push({
            name: 'Groups',
            route: 'Groups',
            imgSrc: Groups,
        });
        DefaultNavItems.push({
            name: '3rd party CCTV',
            route: 'CCTVIntegrations',
            imgSrc: CCTV,
        });
        DefaultNavItems.push({
            name: 'Padlocks',
            route: 'Padlocks',
            imgSrc: Locks,
        });
        DefaultNavItems.push({
            name: 'Keyboxes',
            route: 'Keyboxes',
            imgSrc: Keybox,
        });
        DefaultNavItems.push({
            name: 'Sensors',
            route: 'Sensors',
            imgSrc: Sensor,
        });
        DefaultNavItems.push({
            name: 'Gateways',
            route: 'Gateways',
            imgSrc: GatewayIcon,
        });
    

    if (companyName === "EyeSpyFX" || companyName === "KNOWIO") {
        DefaultNavItems.push({
            name: 'Portal activity',
            route: 'Activity',
            imgSrc: PortalActivity,
        });
    }

    if (companyName === "EyeSpyFX" || companyName === "RE:SURE" || companyName === "KNOWIO"){
        DefaultNavItems.push({
            name: 'Site activity',
            route: 'SiteActivity',
            imgSrc: ActivityIcon,
            end: true
        });
    }

    let logo = "";
    let logoClass;
    switch (brandingName) {
        case "EyeSpyFX":
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
        case "PARFAS":
            logo = ParfasLogo;
            logoClass = classes.logo;
            break;
        case "RE:SURE":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "SOLO":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "PORTAL_SECURITY":
            logo = PortalLogo;
            logoClass = classes.logo;
            break;
        case "CPS":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "EES":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "KNOWIO":
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
        case "CTSG": 
            logo = ctsgLogo;
            logoClass = classes.logo
            break;
        case "Tower Security" :
            logo = TowerLogo;
            logoClass = classes.logo
            break;
        default:
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
    }

    useEffect(() => {
        if (logo !== ""){
            setLoadedLogo(true)
        }
    }, [logo])



    const navSettingsItems = useMemo(() => [
        
    ], []);


    const handleHideSideNav = () => {
        sessionStorage.removeItem("SavedSearchQuery");
        sessionStorage.removeItem("SavedSearchFilters");
        sessionStorage.removeItem("SavedSearchSortOrder");
        sessionStorage.removeItem("isGetAllDevicesPressed");
        dispatch(uiActions.ShowSideNav(false));
    }

    return (
        <Fragment>
            <div className={classes['side-nav']} style={cssClass}>
                <div className={classes["nav-wrapper"]}>
                    <nav style={{ width: "100%" }}>
                        <ul className={classes["nav-listLinks"]}>

                            {brandingName && loadedLogo ? (
                                <img className={logoClass} src={logo} />
                                ) : (
                                <img className={logoClass}  />
                            )}

                            {DefaultNavItems.map((item, index) => (
                                <li
                                    style={{
                                        width: "100%",
                                        cursor: item.disabled ? "" : "pointer",
                                        opacity: item.disabled ? 0.3 : 1,
                                    }}
                                    key={index}
                                >
                                <SideNavItem
                                    route={item.disabled ? null : item.route}
                                    image={item.imgSrc}
                                    text={item.name}
                                    onClick={!item.disabled ? handleHideSideNav : null}
                                    end={item.end}
                                />
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <nav>
                        <ul className={classes["nav-listLinks"]}>
                            {navSettingsItems.map((item, index) => (
                                <li key={index}>
                                    <SideNavItem
                                        route={item.route}
                                        image={item.imgSrc}
                                        text={item.name}
                                    />
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>
        </Fragment>
    );
}

export default SideNav;